/**
 * @ External Dependecies
 */
import { createGlobalStyle } from 'styled-components';

import { media } from 'shared/utilities/media';
import colors from 'shared/constants/colors';

export const GlobalTableStyles = createGlobalStyle`
	.table-alt {
		background: #f9f9f9;
	}

	.table-alt th {
		padding: 10px 8px 5px;
		background: #fff;
		font-size: 10px;
		font-weight: 600;
		text-transform: uppercase;
		color: #8a909c;

		&:first-child {
			padding-left: 46px;
		}
	}

	.table-alt td {
		padding: 14px 8px;
		font-size: 14px;
		font-weight: 600;
		color: ${colors.midnight};

		&:first-child {
			padding-left: 46px;
		}
	}

	.table-simple {
		margin-right: -60px;
		overflow:inherit;
		${media.tablet_portrait`
			padding-right: 0;
			margin-right: 0;
		`}
		th {
			vertical-align: bottom;
			padding: 0 7px 5px 7px;
			background: transparent;
			border-bottom: 1px solid rgba(138, 144, 156, 0.15);
			font-size: 10px;
			font-weight: 600;
			text-transform: uppercase;
			letter-spacing: 0.01em;
			color: #8a909c;
			max-width: 100px;
			white-space: normal;
			&:first-child {
				padding-left: 0;
			}
		}
		
		td {
			padding: 24px 7px;
			border-bottom: 1px solid rgba(138, 144, 156, 0.15);
		}

		td.name {
			padding-left: 5;
			font-size: 14px;
			font-weight: 700;
			color: ${colors.midnight};
			min-width:100px;
  			word-break: break-all;
		}

		td.connectivity {
			font-size: 14px;
			font-weight: 700;
			letter-spacing: 0.01em;
      		max-width: 0;
      		white-space: nowrap;
      		text-overflow: ellipsis;
      		overflow: hidden;

			.error {
				color: ${colors.cherry};
			}

			.success {
				color: ${colors.midnight};
			}
		}

		td.year,
		td.make,
		td.type {
			font-size: 14px;
			font-weight: 600;
			letter-spacing: 0.01em;
			color: #8a909c;
		}

		td.vin {
			font-size: 10px;
			font-weight: 400;
			text-transform: uppercase;
			color: #8a909c;
		}

		td.plate {
			font-size: 12px;
			font-weight: 400;
			letter-spacing: 0.01em;
			color: #8a909c;
		}

		td.model {
			font-size: 14px;
			font-weight: 400;
			letter-spacing: 0.01em;
			color: #8a909c;
		}

		tr:hover {
			background: transparent;
		}

		.jobNameAndIcon {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			align-items: left;
			overflow: hidden;
			word-break: break-all;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			  .svg-icon {
				margin-right: 13px;
				font-size: 0;
			}
		}
	}
	.report-table {
	  tr {
		vertical-align:baseline;
		td {
		  padding:12px 7px;
		  border-bottom: unset;
		}
		&:first-child td {
          padding-top: 24px;
        }
        &:last-child td {
          padding-bottom: 24px;
        }
	  }
	}
`;
